import { Key } from 'react';
import { formatDateTimeString } from '@/utils/helpers';
import { BulkAssignmentCase, CaseUserGroup } from '@/api/apis/case';
import { serviceRegionNameById, ServiceRegionId } from '@/constants/serviceRegion.constants';
import { caseStatusNames } from '@/constants/case/case.constants';
import { BulkAssignmentCaseCell } from './components/BulkAssignmentCaseCell';
import { BulkAssignmentUsersCell } from './components/BulkAssignmentUsersCell';

export const renderBulkAssignmentCell =
  (selectedGroup?: CaseUserGroup) => (item: BulkAssignmentCase, columnKey: Key) => {
    const {
      caseId,
      caseName,
      serviceRegionId,
      donorHospitalDate,
      donorHospitalTime,
      donorHospitalTimeZone,
      organType,
      donorType,
      status,
      assignedEmployees,
    } = item;
    switch (columnKey) {
      case 'case':
        return (
          <BulkAssignmentCaseCell caseId={caseId} caseName={caseName} organType={organType} donorType={donorType} />
        );
      case 'status':
        return <span className="text-m-r">{caseStatusNames[status]}</span>;
      case 'donorORTime':
        return (
          <span className="text-m-r">
            {donorHospitalDate && donorHospitalTime
              ? formatDateTimeString(donorHospitalDate, donorHospitalTime, donorHospitalTimeZone)
              : '-'}
          </span>
        );
      case 'businessRegion':
        return <span className="text-m-r">{serviceRegionNameById[serviceRegionId as ServiceRegionId]}</span>;
      case 'users':
        return <BulkAssignmentUsersCell assignedEmployees={assignedEmployees} selectedGroup={selectedGroup} />;

      default:
        return null;
    }
  };
